import _ from "lodash"

export const MONTHS = [
    "January", "February", "March", "April",
    "May", "June", "July", "August",
    "September", "October", "November", "December"
]

/* Payments recorded from this page carry this fee_name; others are admission fees. */
export const MONTHLY_FEE_NAME = "monthly_fee"

export const formatMoney = (amount) => `₹${Number(amount || 0).toLocaleString("en-IN")}`

/** The class's monthly fee items: [{ feeName, feeAmount }]. */
export const monthlyFeeItems = (classItem) => {
    const items = _.get(classItem, "meta_data.monthlyFee", [])
    return Array.isArray(items) ? items.filter((item) => item && item.feeName) : []
}

export const sumFees = (items) =>
    items.reduce((total, item) => total + Number(item.feeAmount || 0), 0)

/** "d/m/yyyy" → { day, month (1-12), year }, or null. */
const parseDate = (value) => {
    const [day, month, year] = String(value || "").split("/").map((part) => Number(part.trim()))
    if (!month || !year) return null
    return { day, month, year }
}

/**
 * The monthly fee is recorded with payment_date set to the month it pays for,
 * so a year's payments group by that date's month.
 *
 * Returns { [month 1-12]: { amount, date, payments } }.
 */
export const paidMonthsOf = (payments, year) => {
    const byMonth = {}
    ;(Array.isArray(payments) ? payments : []).forEach((payment) => {
        if (payment?.fee_name !== MONTHLY_FEE_NAME) return
        const date = parseDate(payment.payment_date)
        if (!date || date.year !== year) return

        const entry = byMonth[date.month] || { amount: 0, date: payment.payment_date, payments: [] }
        entry.amount += Number(payment.fee_amount || 0)
        entry.payments.push(payment)
        byMonth[date.month] = entry
    })
    return byMonth
}

/** "paid" | "due" | "upcoming" for a month (1-12) of `year`. */
export const monthStatus = (month, year, paidMonths, today = new Date()) => {
    if (paidMonths[month]) return "paid"
    const currentYear = today.getFullYear()
    if (year < currentYear || (year === currentYear && month <= today.getMonth() + 1)) return "due"
    return "upcoming"
}

/** The payment_date for collecting `month` of `year`: today's day, kept inside that month. */
export const paymentDateFor = (month, year, today = new Date()) => {
    const lastDay = new Date(year, month, 0).getDate()
    return `${Math.min(today.getDate(), lastDay)}/${month}/${year}`
}
